
import PageLayout from "@/layouts/PageLayout";
import MerchandiseSection from "@/components/merchandise/MerchandiseSection";
import { Helmet } from "react-helmet-async";

const MerchandisePage = () => {
  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "cheqbooq Merchandise",
    "description": "Exclusive merchandise for supporters of the cheqbooq financial data ownership movement.",
  };

  return (
    <PageLayout pageTitle="cheqbooq | Merchandise">
      <Helmet>
        <title>cheqbooq - Exclusive Movement Merchandise</title>
        <meta name="description" content="Display your commitment to financial data ownership with our exclusive merchandise collection." />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      {/* Page Header */}
      <div className="bg-primary/5 py-16 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="premium-title mb-4">Movement Merchandise</h1>
          <p className="text-lg text-muted-foreground">
            Support the revolution with exclusive merchandise that makes a statement.
          </p>
        </div>
      </div>
      
      {/* Merchandise Section */}
      <MerchandiseSection />
    </PageLayout>
  );
};

export default MerchandisePage;
